export const ENGLISH = {
	NAME: 'ENGLISH',
	LANG_DIRECTION: 'left',
	DIRECTION: 'ltr',
	SEARCH: {
		CHECKBOX_PREFIX: 'I want to look for:',
		DEFAULT_SEARCH_KEYWORD: '',
		DEFAULT_SEARCH_MSG: '',
		RESULT_SEARCH_MSG: 'Results',
		IMITATING: 'Imitating',
		LEVERAGED: 'Leveraged',
		SHORT: 'Short',
		STOCKS: 'Stocks',
		KOSHER: 'Kosher',
		MM: 'Forex Exposure profile: 4A',
		INFO_p1: "For comparison, search for the desired security, on this page you can compare different securities",
		INFO_p2: "You have two comparison options:",
		INFO_p3_blue: "Blue - comparison of a specific security",
		INFO_p4_grey: "Gray - comparison of all index funds",

		NO_RESULT_KEY_WORDS: 'No Results found for the given keywords',
		NO_RESULTS_FOR_FILTERS: 'No Results found for the given filters',
		IN_PROGRESS: 'Searching...',
		TO_MANY_RESULTS: 'Too many results found...',
		NO_NEW_FUND_TO_ADD: 'No new results the arent already in comparation',
		LOADING: 'LOADING...',
		NEW_SEARCH: 'Search',
		ADD_TO_GRAPH: 'Add to comparation',
		MANAGMENT_FEE_FILTER: 'Managment fee',
		MINIMAL_TIME: 'maximal joint starting point',
		PHONE_ROTATION_MESSAGE: 'please rotate the device to watch comparing graph',
	},

	GRAPH: { WEEK_BUTTON: 'week', MONTH_BUTTON: 'month', YEAR_BUTTON: 'year', ALL_TIME_BUTTON: 'all-time' },
	GENERAL: {
		OF: 'of',
	},
	TABLE: {
		DIRECTION: 'ltr',
		STD: 'std',
		MANAGMENT_FEE_HEADER: 'managment fee',
		OVERALL_MANAGMENT_FEE_HEADER: 'total fixed fee',
		TRUST_FEE_HEADER: 'trust fee',
		MANAGMENT_VAR_FEE_HEADER: 'variable fee',
		PRICE_HEADER: 'price',
		FUND_NUMBER_HEADER: 'paper id',
		NAME_HEADER: 'name',
		NO_DATA_HEADER: 'no info avail',
		CALCULATING_DATA_CELL: 'calculating..',
		YIELD_HEADER: 'yield of shown period',
		DELETE_BUTTON: 'delete selected',
	},
	SUGGESTIONS: {
		ALL: 'הראה הכל',
		INDICES: 'all etfs of the index',
		ETFS: 'specific etfs',
	},
	NAV: {
		SEARCH: 'search',
		CONTACT: 'contact',
		FAQ: 'faq',
	},
	SCROLL_FILTER: {
		MANAGMENT_FEE_FILTER: 'Managment fee',
		NO_FILTER: 'dont limit',
	},
};

export const HEBREW = {
	NAME: 'HEBREW',
	LANG_DIRECTION: 'right',
	DIRECTION: 'rtl',

	GENERAL: {
		OF: 'של',
	},
	SEARCH: {
		CHECKBOX_PREFIX: ':אני רוצה לחפש',
		DEFAULT_SEARCH_KEYWORD: '',
		DEFAULT_SEARCH_MSG: '',
		RESULT_SEARCH_MSG: 'תוצאות',
		IMITATING: 'קרן מחקה',
		LEVERAGED: 'קרן ממונפת',
		SHORT: 'קרן בחסר',
		STOCKS: 'מניות',
		KOSHER: 'כשרה',
		MM: 'מנוטרלת מטח',
		INFO_p1: ".בדף זה ניתן להשוות ניירות ערך שונים. לייצרת השוואה חפש את נייר הערך המבוקש",
		INFO_p2: ":לרשותך שתי אפשרויות השוואה",
		INFO_p3_blue: "כחול - השוואת מנייה ספציפית",
		INFO_p4_grey: "אפור - השוואה בין כל קרנות המדד",

		NO_RESULT_KEY_WORDS: 'לא נמצאו תוצאות העונות למילת החיפוש',
		NO_RESULTS_FOR_FILTERS: 'לא נמצאו תוצאות המתאימות לסינונים שנבחרו, יש לבחור פחות סינונים או לשנות מילת חיפוש',
		IN_PROGRESS: '...מחפש',
		TO_MANY_RESULTS: 'נמצאו יותר מידי תוצאות חיפוש , אנא מקד את הפילטרים או מילות חיפוש',
		NO_NEW_FUND_TO_ADD: 'אין תוצאות חדשות שלא בהשוואה',
		LOADING: '...טוען',
		NEW_SEARCH: 'חיפוש',
		ADD_TO_GRAPH: 'הוסף להשוואה',
		CHOSE_REMOVE_ALL: 'בחר / הסר הכל',
		MANAGMENT_FEE_FILTER: 'דמי ניהול עד',
		PHONE_ROTATION_MESSAGE: 'אנא סובב את מסך המכשיר לצפייה בגרף',
	},

	GRAPH: {
		WEEK_BUTTON: 'שבוע',
		MONTH_BUTTON: 'חודש',
		YEAR_BUTTON: 'שנה',
		ALL_TIME_BUTTON: 'הכל',
		MINIMAL_TIME: 'נקודת פתיחה חופפת',
	},

	TABLE: {
		DIRECTION: 'rtl',
		STD: 'שונות',
		MANAGMENT_FEE_HEADER: 'דמי ניהול',
		OVERALL_MANAGMENT_FEE_HEADER: 'דמי ניהול משוקללים',
		TRUST_FEE_HEADER: 'דמי נאמנות',
		MANAGMENT_VAR_FEE_HEADER: 'דמי ניהול משתנים',
		PRICE_HEADER: 'שער',
		FUND_NUMBER_HEADER: "מספר נ''ע",
		NAME_HEADER: 'שם',
		NO_DATA_HEADER: 'לא זמין',
		CALCULATING_DATA_CELL: '...מחשב',
		YIELD_HEADER: 'תשואת התקופה המוצגת',
		DELETE_BUTTON: 'הסר מההשוואה',
	},
	SUGGESTIONS: {
		ALL: 'הראה הכל',
		INDICES: 'כל קרנות המדד',
		ETFS: 'קרן מסויימת',
	},

	NAV: {
		SEARCH: 'חפש',
		CONTACT: 'צור קשר',
		FAQ: 'שאלות ותשובות',
	},
	SCROLL_FILTER: {
		MANAGMENT_FEE_FILTER: 'דמי ניהול עד',
		NO_FILTER: 'בלי הגבלה',
	},
};
